import * as BaseApi from "api/Base.api";
import { IDiary, IDiaryComment, IDiaryLike } from "api/interfaces/profile.interface";
import { IPagination, ILikeToggleResponse } from "api/interfaces/common.interface";

export interface IFetchDiaryDetailResponse {
    diary: IDiary;
}

//* 코치용 다이어리 상세 조회
// 2025.01.XX
// 희문
//* Params
//  diaryId: string - 다이어리 ID
export const fetchDiaryDetail = async (diaryId: string): Promise<IFetchDiaryDetailResponse> => {
    const url = `/koach/v2/diary/${diaryId}`;
    return await BaseApi.get(url);
};

//* 코치용 다이어리 좋아요 토글
// 2025.01.XX
// 희문
//* Params
//  diaryId: string - 다이어리 ID
export const toggleDiaryLike = async (diaryId: string): Promise<ILikeToggleResponse> => {
    const url = `/koach/v2/diary/${diaryId}/like`;
    return await BaseApi.post2(url);
};

export interface IFetchDiaryLikesResponse {
    likeList: IDiaryLike[];
    pagination: IPagination;
}

//* 코치용 다이어리 좋아요 목록 조회
// 2025.01.XX
// 희문
//* Params
//  diaryId: string - 다이어리 ID
//  page: number - 페이지 번호 (기본값: 1)
//  limit: number - 페이지당 개수 (기본값: 20)
export const fetchDiaryLikes = async (diaryId: string, page: number = 1, limit: number = 20): Promise<IFetchDiaryLikesResponse> => {
    const url = `/koach/v2/diary/${diaryId}/like`;
    const params = { page, limit };
    return await BaseApi.get(url, params);
};


export interface IFetchDiaryCommentsResponse {
    commentList: IDiaryComment[];
    pagination: IPagination;
}
//* 코치용 다이어리 코멘트 목록 조회
// 2025.01.XX
// 희문
//* Params
//  diaryId: string - 다이어리 ID
//  page: number - 페이지 번호 (기본값: 1)
export const fetchDiaryComments = async (diaryId: string, page: number = 1): Promise<IFetchDiaryCommentsResponse> => {
    const url = `/koach/v2/diary/${diaryId}/comment`;
    const params = { page };
    return await BaseApi.get(url, params);
};

export interface ICreateDiaryCommentRequest {
    contents: string;
}

export interface ICreateDiaryCommentResponse {
    comment: IDiaryComment;
}

//* 코치용 다이어리 코멘트 작성
// 2025.01.XX
// 희문
//* Params
//  diaryId: string - 다이어리 ID
//  content: string - 코멘트 내용
export const createDiaryComment = async (diaryId: string, content: string): Promise<ICreateDiaryCommentResponse> => {
    const url = `/koach/v2/diary/${diaryId}/comment`;
    const data: ICreateDiaryCommentRequest = { contents: content };
    const response = await BaseApi.post(url, data);
    if (response && response.data && response.data.data) {
        return response.data.data; // response.data.data가 { comment: ... } 형태
    }
    throw new Error("코멘트 작성에 실패했습니다.");
};

//* 코치용 다이어리 코멘트 좋아요 토글
// 2025.01.XX
// 희문
//* Params
//  diaryId: string - 다이어리 ID
//  commentId: string - 코멘트 ID
export const toggleCommentLike = async (diaryId: string, commentId: string): Promise<ILikeToggleResponse> => {
    const url = `/koach/v2/diary/${diaryId}/comment/${commentId}/like`;
    return await BaseApi.post2(url);
};

//* 코치용 다이어리 삭제
// 2025.01.XX
// 희문
//* Params
//  diaryId: string - 다이어리 ID
export const deleteDiary = async (diaryId: string): Promise<void> => {
    const url = `/koach/v2/diary/${diaryId}`;
    await BaseApi.remove(url);
};

//* 코치용 다이어리 코멘트 삭제
// 2025.01.XX
// 희문
//* Params
//  diaryId: string - 다이어리 ID
//  commentId: number - 코멘트 ID
export const deleteDiaryComment = async (diaryId: string, commentId: number): Promise<void> => {
    const url = `/koach/v2/diary/${diaryId}/comment/${commentId}`;
    await BaseApi.remove(url);
};

export interface IReportCommentRequest {
    reportTypeCode: string;
    etcReason?: string;
}

export interface IReportDiaryRequest {
    reportTypeCode: string;
    etcReason?: string;
}

//* 코치용 다이어리 코멘트 신고
// 2025.01.XX
// 희문
//* Params
//  diaryId: string - 다이어리 ID
//  commentId: string - 코멘트 ID
//  reportTypeCode: string - 신고 사유 코드
//  etcReason?: string - 상세 사유 (선택사항)
export const reportComment = async (diaryId: string, commentId: string, reportTypeCode: string, etcReason?: string): Promise<void> => {
    const url = `/koach/v2/diary/${diaryId}/comment/${commentId}/report`;
    const data: IReportCommentRequest = { 
        reportTypeCode,
        ...(etcReason && { etcReason })
    };
    await BaseApi.post(url, data);
};

//* 코치용 다이어리 신고
// 2025.01.XX
// 희문
//* Params
//  diaryId: string - 다이어리 ID
//  reportTypeCode: string - 신고 사유 코드
//  etcReason?: string - 상세 사유 (선택사항)
export const reportDiary = async (diaryId: string, reportTypeCode: string, etcReason?: string): Promise<void> => {
    const url = `/koach/v2/diary/${diaryId}/report`;
    const data: IReportDiaryRequest = { 
        reportTypeCode,
        ...(etcReason && { etcReason })
    };
    await BaseApi.post(url, data);
};
